import { useState } from 'preact/hooks';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { formatUsd } from 'shared';
import { cartDueToday, cartLines } from '@/state/pricing.js';
import { OutreachOrderLines } from '@/flows/outreach/components/order-lines.js';

/**
 * The running order, one tap away. The thread scrolls, so a plan chosen four bubbles ago is
 * off-screen by the time the next one is being configured — this is the marketplace order
 * summary, folded into the header.
 */
export function OutreachCart() {
  const [open, setOpen] = useState(false);
  const lines = cartLines.value;
  const count = lines.length;

  return (
    <div className="sm-chat-cart">
      <button
        type="button"
        className="sm-center sm-chat-header-icon-btn sm-chat-cart-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={
          count === 0 ? 'Your order — nothing selected yet' : `Your order — ${count} selected`
        }
      >
        <ShoppingBagIcon size={18} aria-hidden="true" />
        {count > 0 && (
          <span className="sm-type-eyebrow sm-center sm-chat-cart-count" aria-hidden="true">
            {count}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="sm-chat-cart-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div
            className="sm-panel sm-stack sm-chat-cart-panel"
            role="dialog"
            aria-label="Your order"
          >
            <div className="sm-chat-cart-head">
              <p className="sm-type-eyebrow">Your order</p>
              <button
                type="button"
                className="sm-center sm-chat-cart-close"
                onClick={() => setOpen(false)}
                aria-label="Close"
              >
                <XIcon size={16} aria-hidden="true" />
              </button>
            </div>

            {count === 0 ? (
              <p className="sm-type-body sm-muted">
                Nothing selected yet. Tap a plan in the chat to add it.
              </p>
            ) : (
              <>
                <OutreachOrderLines />
                <div className="sm-stack sm-totals">
                  <div className="sm-type-body-strong sm-tabular sm-totals-row" data-tone="total">
                    <span>Due today</span>
                    <span>{formatUsd(cartDueToday.value)}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}
